import { ApiUtility } from "../../Utilities/ApiUtility.axios";
import { TimeUnits } from "./SettingService";

export enum VoucherMode {
  Normal,
  Opening,
  Closing,
}
export enum Party_Tax {
  other,
  party,
  tax,
  BanknCash,
  TangibleFixedAsset,
  Depreciation,
  RoundOff,
  Discount,
  CC,
  BadDebts,
  AccumulatedDepreciation,
  Stock,
  Capital,
}
export enum Voucher_Type {
  All,
  SalesVoucher,
  CreditNote,
  PurchaseVoucher,
  DebitNote,
  Payment,
  Receipt,
  Contra,
  PurchaseOrder,
  SalesOrder,
  Journal,
  Quotation,
  ExportInvoice,
  DeemedExportInvoice,
  SEZInvoice,
  ExportBill,
  DeemedExportBill,
  SEZBill,
  RCMBill,
  ExpenseJV,
  DChallan,
  RChallan,
  Asset,
  StockVoucher,
  Requisition,
  Expenses,
  Income,
  PInvoice,
}
export enum ReconcileTypes {
  Both,
  Reconciled,
  Nonreconciled,
}

export enum LedgerTypes {
  All,
  PartiesOnly,
  PartiesWithBank,
  BankAndCash,
  Sales,
  Purchase,
  DirectExpenses,
  IndirectExpenses,
  PaymentIn,
  PaymentOut,
  DutiesAndTaxes,
}
export enum VoucherFilterStatus {
  All,
  Active,
  Due,
  Overdue,
  Paid,
  Deleted,
  Draft,
}
export enum OrderStatus {
  All,
  Pending,
  Completed,
  Deleted,
  Draft,
}

export const OrderStatusList = [
  { label: "All", value: OrderStatus.All },
  { label: "Pending", value: OrderStatus.Pending },
  { label: "Completed", value: OrderStatus.Completed },
  { label: "Deleted", value: OrderStatus.Deleted },
  { label: "Draft", value: OrderStatus.Draft },
];

export enum VoucherStatus_New {
  Active,
  Deleted,
}

export enum AddressEnum {
  BillingAddress,
  ShippingAddress,
}

export enum RefType {
  newRef,
  AgnstRef,
}

export enum ReconciledFilter {
  both,
  reconciled,
  nonreconciled,
}

export enum Freight_Type {
  EXW = 1,
  FOB,
  CIF,
  CFR,
  FCA,
  CPT,
  CIP,
  DAP,
  DPU,
  DDP,
  FAS,
}

export const FreightTypeOptions = [
  { value: Freight_Type.EXW, label: "Ex-Works" },
  { value: Freight_Type.FOB, label: "Free on Board" },
  { value: Freight_Type.CIF, label: "Cost, Insurance and Freight" },
  { value: Freight_Type.CFR, label: "Cost and Freight" },
  { value: Freight_Type.FCA, label: "Free Carrier" },
  { value: Freight_Type.CPT, label: "Carriage Paid to" },
  { value: Freight_Type.CIP, label: "Carriage and Insurance Paid To" },
  { value: Freight_Type.DAP, label: "Delivered at Place" },
  { value: Freight_Type.DPU, label: "Delivered at Place Unloaded" },
  { value: Freight_Type.DDP, label: "Delivered Duty Paid" },
  { value: Freight_Type.FAS, label: "Free Alongside Ship" },
];

export enum OpeningEntry_Categories {
  none,
  customer,
  supplier,
  fixedAssets,
  stock,
  otherThanFixedAssets,
  liability,
  cashBank,
  capital,
}

export enum ITCEligibility_Type {
  Available,
  UnvailableUOther,
  UnavailableUs17_5,
}

export const ITCEligibilityTypeOptions = [
  {
    value: ITCEligibility_Type.Available,
    label: "Eligible for ITC",
    title: "",
  },
  {
    value: ITCEligibility_Type.UnvailableUOther,
    label: "Ineligible - Other",
    title: "",
  },
  {
    value: ITCEligibility_Type.UnavailableUs17_5,
    label: "Ineligible - u/Sec. 17(5)",
    title: "",
  },
];

export enum RCMFilter {
  Both,
  RCM,
  NonRCM,
}

export const RCMFilterOptions = [
  { value: RCMFilter.Both, label: "RCM / Non-RCM" },
  { value: RCMFilter.RCM, label: "RCM" },
  { value: RCMFilter.NonRCM, label: "Non RCM" },
];

export enum Transport_Mode {
  ByRoad,
  ByAir,
  ByOcean,
}

export const Transport_ModeOptions = [
  { value: Transport_Mode.ByRoad, label: "By Road" },
  { value: Transport_Mode.ByAir, label: "By Air" },
  { value: Transport_Mode.ByOcean, label: "By Ocean" },
];

export enum CashCreditFilter {
  All,
  CashOnly,
  CreditOnly,
}

export const CashCreditFilterOptions = [
  { value: CashCreditFilter.All, label: "Cash / Credit" },
  { value: CashCreditFilter.CashOnly, label: "Cash Only" },
  { value: CashCreditFilter.CreditOnly, label: "Credit Only" },
];

export enum PeriodRange {
  Unspecified,
  Today,
  Yesterday,
  CurrentWeek,
  LastWeek,
  ThisMonth,
  LastMonth,
  //ThisYear,
  //LastYear
}
export enum Voucher_Nature {
  Regular,
  RCM,
  //B2C,
  //B2B,
  ImportExport,
  DeemedExport,
  SEZ,
}
export const voucherNatureOptions = [
  { label: "Regular", value: Voucher_Nature.Regular, title: "" },
  { label: "Export/Import", value: Voucher_Nature.ImportExport, title: "" },
  {
    label: "Deemed Export/Import",
    value: Voucher_Nature.DeemedExport,
    title: "",
  },
  { label: "SEZ", value: Voucher_Nature.SEZ, title: "" },
  { label: "Reverse Charge (RCM)", value: Voucher_Nature.RCM, title: "" },
];

export const addVoucherNatureOptions = {
  label: "Reverse Charge (RCM)",
  value: Voucher_Nature.RCM,
};

export const expensesIncomeNatureOptions = [
  { label: "Regular", value: Voucher_Nature.Regular },
];

export const addVoucherExpensesIncomeptions = {
  label: "Reverse Charge (RCM)",
  value: Voucher_Nature.RCM,
};

export const convertToDays = (duration: number, durationUnit?: TimeUnits) => {
  let days;
  if (duration <= 0) {
    return 0;
  } else {
    switch (durationUnit) {
      case TimeUnits.Day:
        days = duration;
        break;
      case TimeUnits.Week:
        days = duration * 7;
        break;
      case TimeUnits.Month:
        days = duration * 30; // Approximation, adjust as necessary
        break;
      case TimeUnits.Year:
        days = duration * 365; // Approximation, adjust as necessary
        break;
      default:
        throw new Error("Invalid duration unit");
    }
    return days;
  }
};

export enum DiscountType {
  NoDiscount,
  PercentageDiscount,
  RupeeDiscount,
}

export interface PriceHistoryByItemIdResponse {
  voucherId: string;
  voucherNumber: string;
  partyName: string;
  voucherDate: string;
}

class VoucherService {
  route = `V1/API/Billing/Acc_New_Voucher`;

  //localhost:7142/v1/API/Acc_New_Voucher/65cdd05235241f48a55de738/GetVoucherListByPartyId?voucherType=2&voucherType=660a7f238413a5a73dd8ca11

  getVoucherListByPartyId = (
    companyId: string,
    voucherType: Voucher_Type,
    partyId: string
  ) =>
    ApiUtility.get(`${this.route}/${companyId}/GetVoucherListByPartyId`, {
      voucherType,
      partyId,
    });

  // GetMaxVoucherDate;
  // https://localhost:7142/v1/API/Acc_New_Voucher/6646e10e5038e585a6b5e816/GetMaxVoucherDate?voucherType=1
  getMaxVoucherDate = (companyId: string, voucherType: Voucher_Type) =>
    ApiUtility.get(`${this.route}/${companyId}/GetMaxVoucherDate`, {
      voucherType,
    });

  // GetPriceHistoryByItemId;
  // https://localhost:7142/v1/API/Acc_New_Voucher/6646e10e5038e585a6b5e816/GetPriceHistoryByItemId?voucherType=1,ItemId='6646e10e5038e585a6b5e816'
  getPriceHistoryByItemId = (
    companyId: string,
    voucherType: Voucher_Type,
    ItemId: string,
    SearchForItem: boolean
  ) =>
    ApiUtility.get(`${this.route}/${companyId}/GetPriceHistoryByItemId`, {
      voucherType,
      ItemId,
      SearchForItem,
    });

  // https: //localhost:7142/v1/API/Acc_New_Voucher/65cdd05235241f48a55de738/GetVoucherMaxNo?voucherType=1
  //get party vise references max no
  getVoucherMaxNo = (
    companyId: string,
    voucherType: Voucher_Type,
    voucherDate: any,
    templateId: number
  ) =>
    ApiUtility.get(
      `${this.route}/${companyId}/GetVoucherMaxNo?voucherType=${voucherType}`,
      {
        templateId,
        voucherDate,
      }
    );

  //https://localhost:7142/v1/API/Acc_New_Voucher/65cdd05235241f48a55de738/GetReferencesByParty?partyId=65d74367983b0a7e7dda7721

  // get party vise references
  getReferencesByParty = (
    companyId: string,
    partyId: string,
    voucher_Type: Voucher_Type
  ) =>
    ApiUtility.get(`${this.route}/${companyId}/GetReferencesByParty`, {
      partyId,
      voucher_Type,
    });

  // // Download/CSV

  // exportCsv = (
  //   companyId: any,
  //   voucherType: Voucher_Type | any,
  //   from: string,
  //   to: string,
  //   start: number,
  //   length: number,
  //   sortCol?: string,
  //   sortDir?: string,
  //   partyId?: string,
  //   reconciled?: ReconcileTypes | any,
  //   search?: string,
  //   status?: VoucherFilterStatus
  // ) =>
  //   ApiUtility.downloadFile(`${this.route}/${companyId}/Download/CSV`, {
  //     voucherType,
  //     start,
  //     length,
  //     from,
  //     to,
  //     sortCol,
  //     sortDir,
  //     partyId,
  //     reconciled,
  //     search,
  //     status,
  //   });
  // public async Task<IActionResult> DownloadCSV(string companyId, Voucher_Type voucherType, int start = 0, int length = 15, string from = null, string to = null, string sortCol = "", string sortDir = "", string partyId = null, ReconciledFilter reconciled = ReconciledFilter.both, string search = "", VoucherFilterStatus status = VoucherFilterStatus.Active)

  //https://localhost:7142/v1/API/Acc_New_Voucher/65cdd05235241f48a55de738/GetList?voucherType=0&start=0&length=15&partyId=65d5a8435b08e02630da8017
  //https://localhost:7142/v1/API/Acc_New_Voucher/65cdd05235241f48a55de738/GetList?voucherType=0&start=0&length=15&from=20-03-2024&to=20-03-2024

  getVoucharList = (
    companyId: any,
    voucherType: Voucher_Type | any,
    from: string,
    to: string,
    start: number,
    length: number,
    sortCol?: string,
    sortDir?: string,
    partyId?: string,
    reconciled?: ReconcileTypes | any,
    search?: string,
    status?: VoucherFilterStatus,
    itemId?: string,
    // PeriodRange
    rCMFilter?: RCMFilter,
    cashCreditFilter?: CashCreditFilter,
    requestModel?: any
  ) =>
    ApiUtility.get(`${this.route}/${companyId}/GetList`, {
      voucherType,
      from,
      to,
      start,
      length,
      sortCol,
      sortDir,
      partyId,
      reconciled,
      search,
      status,
      itemId,
      rCMFilter,
      cashCreditFilter,
      requestModel,
    });

  //https: //localhost:7142/v1/API/Acc_New_Voucher/65cdd05235241f48a55de738/65faa00a2200123bddd4a24e?voucherType=10

  // get Vouchar Id
  getVoucharById = (
    companyId: string | undefined,
    voucharId: string | undefined,
    voucherType?: Voucher_Type
  ) =>
    ApiUtility.get(`${this.route}/${companyId}/${voucharId}`, {
      voucherType,
    });

  //https://localhost:7142/v1/API/Acc_New_Voucher/65cdd05235241f48a55de738/65fd5954085e97708cd14693?voucherType=10
  // post Ledger Api

  postVoucher = (
    companyId: string | undefined,
    voucherType: Voucher_Type | undefined,
    params: any,
    id?: string
    // attachments?: any,
    // config?: string,
  ) =>
    ApiUtility.postForm(
      `${this.route}/${companyId}${
        id ? "/" + id : ""
      }?voucherType=${voucherType}`,
      params
      // config,
      // attachments,
    );

  // https: //localhost:7142/v1/API/Acc_New_Voucher/65cdd05235241f48a55de738/66211d2d3a14b834a3366c28
  // delete vouchar api
  deleteVoucher = (companyId: string | undefined, voucherId: string) =>
    ApiUtility.delete(`${this.route}/${companyId}/${voucherId}`);

  postReconcileVoucher = (companyId: string | undefined, reconciledData: any) =>
    ApiUtility?.post(
      `${this.route}/${companyId}/ReconcileVoucher`,
      reconciledData
    );

  postLockVoucherMonth = (
    companyId: string | undefined,
    LockMonth: string,
    LockType: boolean
  ) =>
    ApiUtility?.post(
      `${this.route}/${companyId}/PostLockVoucherMonth?LockMonth=${LockMonth}&LockType=${LockType}`,
      {}
    );
  getLockVoucherMonths = (companyId: string | undefined) =>
    ApiUtility?.get(`${this.route}/${companyId}/GetLockVoucherMonths`);

  // https://localhost:7142/v1/API/Acc_New_Voucher/6646e10e5038e585a6b5e816/OpeningEntry

  openingEntryGet = (companyId: string) =>
    ApiUtility.get(`${this.route}/${companyId}/OpeningEntry`);

  GetLastReconcileHistory = (companyId: string | undefined, ledgerId: string) =>
    ApiUtility.get(
      `${this.route}/${companyId}/LedgerId/${ledgerId}/GetLastReconcileHistory`
    );

  GetAllReconcileHistory = (
    companyId: string | undefined,
    ledgerId: string,
    fromDate: string,
    toDate: string
  ) =>
    ApiUtility.get(
      `${this.route}/${companyId}/LedgerId/${ledgerId}/GetAllReconcileHistory?fromDate=${fromDate}&toDate=${toDate}`
    );
}
export default new VoucherService();
